import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const DeliveryIcon: React.FC<Props> = (props) => {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.97632 18.5027H15.5016"
        stroke="#333333"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="17.0021"
        cy="18.5027"
        r="1.50063"
        stroke="#333333"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="5.47572"
        cy="18.5027"
        r="1.50063"
        stroke="#333333"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.99585 13.8617H14.5011C14.7773 13.8617 15.0013 13.6377 15.0013 13.3615V6.9979C15.0013 5.89287 14.1055 4.99707 13.0004 4.99707H3.99668C2.89165 4.99707 1.99585 5.89287 1.99585 6.9979V17.5023C1.99585 18.0548 2.44375 18.5027 2.99627 18.5027H3.97493"
        stroke="#333333"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0015 6.99792H18.2494C19.3023 6.99792 20.2424 7.6573 20.6009 8.64723L21.8848 12.1918C21.9639 12.4102 22.0044 12.6408 22.0044 12.8732V17.0021C22.0044 17.8309 21.3325 18.5027 20.5038 18.5027H18.5029"
        stroke="#333333"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.0044 13.0004H19.0031L18.2957 12.293C18.1081 12.1054 17.8537 12 17.5883 12H15.0015"
        stroke="#333333"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DeliveryIcon;
